import { useMemo } from 'react';
import { KakaoMap } from './KakaoMap';
import { LeafletMapSimple } from './LeafletMapSimple';
import { getMapProvider, MapProvider } from 'common/utils/regionDetector';
import { MapProps } from './types';

interface MapContainerProps extends MapProps {
    forceProvider?: MapProvider;
    /** (deprecated) 해외 장소 CTA 잔재 — 현재는 사용 안 함 */
    placeName?: string;
    placeAddress?: string;
}

/**
 * 지도 추상화 컨테이너
 *
 * 국내 → 카카오맵 (JavaScript SDK). 모임이든 국내 여행이든 늘 카카오입니다.
 * 해외 → Leaflet + OSM. 미니든 전체든 같습니다.
 *
 *   · 카카오맵 tile 은 국내 좌표계라 해외에서는 흰 zoom-out 이 됩니다.
 *   · 웹뷰 안에서 구글 지도(Maps JavaScript API)는 쓰지 않습니다. 지도 로드마다
 *     과금되기 때문입니다. 앱에서는 해외 지도를 네이티브(react-native-maps)로
 *     넘기고, 브라우저에서는 무료인 OSM 타일을 씁니다.
 *   · CARTO 는 basemap 에 키를 요구하게 바뀌어 워터마크가 찍히므로 OSM 기본 타일입니다.
 */
export const MapContainer: React.FC<MapContainerProps> = ({
    center,
    markers,
    routes,
    height = 300,
    zoomLevel = 4,
    forceProvider,
    showMyLocationBtn,
    fitBounds,
    focusTarget,
    viewAllTrigger,
}) => {
    const provider = useMemo(() => {
        if (forceProvider) return forceProvider;
        return getMapProvider(center);
    }, [forceProvider, center]);

    if (provider === 'kakao') {
        return (
            <KakaoMap
                center={center}
                markers={markers}
                routes={routes}
                height={height}
                zoomLevel={zoomLevel}
                showMyLocationBtn={showMyLocationBtn}
                fitBounds={fitBounds}
                focusTarget={focusTarget}
                viewAllTrigger={viewAllTrigger}
            />
        );
    }

    return (
        <LeafletMapSimple
            center={center}
            markers={markers}
            routes={routes}
            height={height}
            zoomLevel={zoomLevel}
            showMyLocationBtn={showMyLocationBtn}
            fitBounds={fitBounds}
            focusTarget={focusTarget}
            viewAllTrigger={viewAllTrigger}
        />
    );
};
